import { TourStep } from "../components/tour-step.js";
import { i18n } from "../../../utils/i18n.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/core/utils/tour.tsx
var styles = {
	popover: (base) => ({
		...base,
		borderRadius: "8px"
	}),
	maskArea: (base) => ({
		...base,
		rx: 8
	}),
	badge: (base) => ({
		...base,
		backgroundColor: "#239bf6"
	})
};
var badgeContent = ({ totalSteps, currentStep }) => `${currentStep + 1}/${totalSteps}`;
var MENU_ANCHOR = "div[aria-label=\"Abrir Menu\"] > button";
var TOOLBAR_ANCHOR = "div[aria-label=\"Barra de ferramentas\"]";
var getMenuSteps = (ref, setOnboardingShowed) => [{
	selector: ref ? ref?.current?.querySelector(MENU_ANCHOR) : MENU_ANCHOR,
	content: /* @__PURE__ */ jsx(TourStep, {
		title: i18n._(
			/** i18n */
			{ id: "zucql-" }
		),
		description: i18n._(
			/** i18n */
			{ id: "OpJoOS" }
		)
	}),
	position: [14, 100]
}, {
	selector: ref ? ref?.current?.querySelector(TOOLBAR_ANCHOR) : TOOLBAR_ANCHOR,
	content: /* @__PURE__ */ jsx(TourStep, {
		title: i18n._(
			/** i18n */
			{ id: "mJeRW7" }
		),
		description: i18n._(
			/** i18n */
			{ id: "aeXqc5" }
		)
	}),
	actionAfter: async () => await setOnboardingShowed()
}];
//#endregion
export { MENU_ANCHOR, TOOLBAR_ANCHOR, badgeContent, getMenuSteps, styles };
